const components = {
    MuiCard: {
        styleOverrides: {
            root: {
                borderRadius: '8px',
                padding: '16px',
                boxShadow: 'none',
            },
        },
    },
    MuiInput: {
        defaultProps: {
            inputProps: {
                sx: {
                    '&::placeholder': {
                        opacity: 1,
                        fontSize: '1.2rem',
                        color: '#E2E8F0',
                    },
                },
            },
        },
    },
    MuiButton: {
        styleOverrides: {
            root: {
                boxShadow: 'none',
            },
        },
    },
};
export default components;
